import styled from 'styled-components';
import zindex from '../../zindex';

/** Ширина сайдбара благосостояния; под длинные суммы (₽ + знак + ~12 цифр). */
export const SIDEBAR_WIDTH_PX = 320;
export const SIDEBAR_CLOSED_LEFT_PX = -(SIDEBAR_WIDTH_PX - 35);

export const ActivesContainer = styled.div`
  margin-left: 20px;
  margin-top: 20px;
`;

export const ActiveGroupContainer = styled.div`
  margin-top: 15px;
`;

export const RowHeader = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  margin: 5px 0;

  & > div.active-name {
    text-align: left;
    flex: 0 1 36%;
    min-width: 0;
    max-width: 36%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  & > div.active-data {
    text-align: right;
    color: #7b7b7b;
    margin-right: 35px;
    flex: 1 1 auto;
    min-width: 0;
    word-break: keep-all;
    overflow: hidden;
    white-space: nowrap;
  }

  & > div.active-arrow {
    flex-basis: 25px;
    position: relative;
    margin-right: 5px;

    img {
      position: absolute;
      top: -9px;
    }
  }

  img {
    margin-right: 8px;
    vertical-align: middle;
    width: 15px;
    height: 15px;
    cursor: pointer;
  }

  .grey {
    color: #7f818d;
  }

  img.active {
    transform: rotate(180deg);
  }
`;

/** Основной контент панели — при свёрнутом сайдбаре скрывается через Container. */
export const SidebarPanelBody = styled.div`
  overflow: hidden;
`;

export const Container = styled.div`
  z-index: ${zindex.sidebar};
  background: #fff;
  color: #000;
  box-sizing: border-box;
  width: ${SIDEBAR_WIDTH_PX}px;
  flex-basis: ${SIDEBAR_WIDTH_PX}px;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  height: auto;
  position: absolute;
  transition: left 0.4s ease;
  display: block;
  left: ${SIDEBAR_CLOSED_LEFT_PX}px;

  &:not(.sidebar-open) ${SidebarPanelBody} {
    visibility: hidden;
    pointer-events: none;
    height: 0;
    overflow: hidden;
  }

  box-shadow:
    rgb(38 38 38 / 4%) 0px 1px 2px,
    rgb(38 38 38 / 16%) 0px 4px 8px;
  margin: 29px 0;
  border-radius: 16px;

  &.sidebar-open {
    left: 17px;
    overflow: auto;
  }

  &::-webkit-scrollbar {
    width: 4px;
    background-color: #252527;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #f7c000;
    border-radius: 2px;
  }
`;

export const ArrowImg = styled.img`
  position: absolute;
  right: 15px;
  top: 29px;
  cursor: pointer;
  transform: rotate(180deg);

  &.sidebar-open {
    transform: rotate(0deg);
  }
`;
export const BalanceImg = styled.img`
  position: absolute;
  right: 12px;
  top: 61px;
  cursor: pointer;
`;

export const RefreshImg = styled.img`
  position: absolute;
  right: 12px;
  top: 90px;
  cursor: pointer;
  width: 16px;
`;

export const BalanceContainer = styled.div`
  padding: 24px;

  div {
    padding: 24px 0 0 0;
    display: flex;
  }

  div:first-child {
    padding: 0;
  }

  img {
    cursor: pointer;
    margin-right: 10px;
  }
`;

export const ParentNest = styled.div``;
export const ChildNest = styled.div``;
export const Child = styled.div`
  margin: 10px 0 10px 30px;
  cursor: pointer;
  padding: 8px;

  &.active {
    background: #4378ff;
    border-radius: 8px;

    div {
      color: #fff !important;
    }
  }
`;
export const NestContainer = styled.div`
  margin: 10px 24px 0 24px;
`;
export const NestBody = styled.div`
  display: none;

  &.active {
    display: block;
  }
`;
export const NestHeader = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 8px;
  margin-top: 8px;

  &.active {
    background: #4378ff;
    border-radius: 8px;

    h1 {
      color: #fff;
    }

    .active-arrow {
      transform: rotate(180deg);
    }
  }

  h1 {
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    letter-spacing: 0;
    text-align: left;
  }
`;
